<template>
  <div class="popup-form d-flex" :class="{'popup-manager': clientFlowData}">
    <div class="w-50 taskList white client-flow-panel" v-if="clientFlowData">
      <div class="client-flow-heading">
        <div>
          <div class="client-flow-eyebrow">Práca s klientom</div>
          <div class="client-flow-title">Postup úloh</div>
        </div>
        <div class="client-flow-count">{{ flowCompletedCount }}/{{ clientFlowChoices.length }}</div>
      </div>
      <div class="client-flow-progress" aria-hidden="true">
        <span :style="{width: flowProgressWidth}"></span>
      </div>
      <div class="client-flow-list">
        <button
          v-for="(option, index) in clientFlowChoices"
          :key="option.value"
          type="button"
          class="client-flow-task"
          :class="flowTaskState(index)"
          @click="toggleClientFlowOption(option.value)"
        >
          <span class="client-flow-marker">
            <span v-if="index <= currentFlowIndex">✓</span>
            <span v-else>{{ index + 1 }}</span>
          </span>
          <span class="client-flow-copy">
            <strong>{{ option.display_name }}</strong>
            <small>{{ flowTaskHint(index) }}</small>
          </span>
        </button>
      </div>
    </div>
    <div class="content-form-popup" :class="{'w-50': clientFlowData}">
      <div class="header-text">
        <button type="button" class="back-button-wrapper pointer" aria-label="Zavrieť údaje klienta" @click="closePopup">
          <app-icon name="close" :size="24" />
        </button>
      </div>
      <div v-if="loading" class="client-load-state" role="status">
        <v-progress-circular indeterminate :size="24" />
        <span>Načítavam údaje klienta…</span>
      </div>
      <div v-else-if="loadError" class="client-load-state" role="alert">
        <p>{{ loadError }}</p>
        <button type="button" class="client-consultation-cta" @click="loadClient">Skúsiť znova</button>
      </div>
      <template v-else-if="clientLoaded">
      <div class="payload-name-block">
        <div class="client-name-block justify-content-between">
          <div class="d-flex flex-row align-items-center">
            <img
              alt=""
              class="image-10"
              loading="lazy"
              src="https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f37_avatar%20cropped.png"
            />
            <div class="div-block-28">
              <div class="light-text lightgrey">
                {{ clientData.email.includes("@nomail.bankari.sk") ? 'Neregistrovaný klient' : 'Klient' }}
              </div>
              <div class="dark-blue-cta-text">
                <div class="blc-color">
                  {{ constructClientLabel() }}
                </div>
              </div>
              <!-- pozvánka klienta dočasne zakomentovaná -->
              <!-- <div
                class="text-small bl-color pointer invite-button"
                @click="inviteClient(clientData.id)"
              >
                + pozvať do aplikácie
              </div> -->
            </div>
          </div>

          <client-personal-info-handler
            :client-info="getClientInfo()"
            :client-profile="clientData.client_profile"
            :rules="['single']" icon-button
          />
        </div>
      </div>
      <div class="email-cta">
        <app-icon class="contact-icon" name="mail" :size="22" />
        <div class="cta-email">
          <div class="light-text lightgrey">Email</div>
          <a
            :href="`mailto:${clientData.email.includes('@nomail.bankari.sk') ? '' : clientData.email}`"
            class="blc-color pointer"
            target="_blank"
          >
            {{ clientData.email.includes("@nomail.bankari.sk") ? "" : clientData.email }}
          </a>
        </div>
      </div>

      <button class="client-consultation-cta" type="button" @click="openConsultation">
        <span class="client-consultation-cta__icon">
          <app-icon name="calendar" :size="28" />
        </span>
        <span>
          <strong>Naplánovať online konzultáciu</strong>
          <small>Otvoriť kalendár, vybrať termín a poslať klientovi pozvánku</small>
        </span>
        <span aria-hidden="true">›</span>
      </button>

      <div class="email-cta">
        <app-icon class="contact-icon" name="phone" :size="22" />
        <div class="cta-email">
          <div class="light-text lightgrey">Telefón</div>
          <div class="blc-color">
            <a
              :href="`tel:${ clientData?.client_profile?.telephone }`"
              class="blc-color pointer"
              target="_blank"
            >
              {{ clientData?.client_profile?.telephone }}
            </a>
          </div>
        </div>
      </div>

      <div class="popup-block d-flex flex-column status-list">
        <div
          class="status-option d-flex justify-content-start pointer"
          :class="{'is-selected': clientData.client_profile.ob_status === 'rozpracovaný'}"
          @click="setClientObStatus('rozpracovaný')"
        >
          <div class="checkboxWrapper" :class="{'is-selected': clientData.client_profile.ob_status === 'rozpracovaný'}">
            <app-icon v-if="clientData.client_profile.ob_status === 'rozpracovaný'" name="check" :size="15" />
          </div>
          <div class="cta-email">
            rozpracovaný
          </div>
        </div>

        <div
          class="status-option d-flex justify-content-start pointer"
          :class="{'is-selected': clientData.client_profile.ob_status === 'cakacka'}"
          @click="setClientObStatus('cakacka')"
        >
          <div class="checkboxWrapper" :class="{'is-selected': clientData.client_profile.ob_status === 'cakacka'}">
            <app-icon v-if="clientData.client_profile.ob_status === 'cakacka'" name="check" :size="15" />
          </div>
          <div class="cta-email">
            čakačka
          </div>
        </div>

        <div
          class="status-option d-flex justify-content-start pointer"
          :class="{'is-selected': clientData.client_profile.ob_status === 'servis'}"
          @click="setClientObStatus('servis')"
        >
          <div class="checkboxWrapper" :class="{'is-selected': clientData.client_profile.ob_status === 'servis'}">
            <app-icon v-if="clientData.client_profile.ob_status === 'servis'" name="check" :size="15" />
          </div>
          <div class="cta-email">
            servis
          </div>
        </div>

        <div
          class="status-option d-flex justify-content-start pointer"
          :class="{'is-selected': clientData.client_profile.ob_status === 'archivovany'}"
          @click="archiveClient(null,true)"
        >
          <div class="checkboxWrapper" :class="{'is-selected': clientData.client_profile.ob_status === 'archivovany'}">
            <app-icon v-if="clientData.client_profile.ob_status === 'archivovany'" name="check" :size="15" />
          </div>
          <div class="cta-email">
            archív
          </div>
        </div>
      </div>

      <button class="quick-processed-deal" type="button" @click="openQuickProcessedMortgage">
        <span class="quick-processed-deal__icon">✓</span>
        <span class="quick-processed-deal__copy">
          <strong>Rýchlo zaevidovať obchod</strong>
          <small>Už načerpaná hypotéka bez prepočtu a celého procesu</small>
        </span>
        <span class="quick-processed-deal__arrow">›</span>
      </button>

      <div class="primary d-flex justify-content-between popupSection">
        <span class="text-small bl-color pointer">HYPOTÉKY KLIENTA</span>
        <span @click="createMortgage">+ pridať</span>
      </div>

      <div v-for="(mortgage) in clientData.mortgages" :key="mortgage.id" class="popup-block div-block-101 pointer client-mortgage"
           :class="{'is-current-mortgage': currentMortgageId === Number(mortgage.id)}"
           :aria-current="currentMortgageId === Number(mortgage.id) ? 'page' : null"
           @click="openMortgage(mortgage.id)">
        <div class="wrap">
          <div class="primary client-mortgage__title">
            {{ getChoicesFromFormByKey("hlavny_ucel", mortgage.hlavny_ucel) }}
            <span v-if="currentMortgageId === Number(mortgage.id)" class="client-mortgage__current">
              Aktuálne otvorená
            </span>
          </div>
          <div class="light-text">
            <span class="black">{{ getMortgageAmount(mortgage) }} EUR</span>
            {{ getChoicesFromFormByKey("stage", mortgage.stage) }} od {{ getDate(mortgage.modified) }}
          </div>
        </div>
      </div>

      <div class="primary d-flex justify-content-between popupSection">
        <span class="text-small bl-color pointer">POZNÁMKY KLIENTA</span>
        <client-note-handler :client="clientData"/>
      </div>

      <div class="d-flex flex-column-reverse">
        <div v-for="(note) in clientData.client_profile.client_notes" :key="note.id" class="popup-block">
          <div class="bold primary">
            zo dňa {{ getDate(note.created) }}
          </div>
          <span class="overflow-wrap-break">{{ note.note }}</span>
        </div>
      </div>
      </template>
    </div>
  </div>
</template>

<script>
import BrokerPickerHandler from "../BrokerPicker/BrokerPickerHandler";
import MortgagePickerHandler from "../MortgagePicker/MortgagePickerHandler";
import {getClientById, inviteClientById} from "@/services/brokerService";
import ClientChatHandler from "../ClientChat/ClientChatHandler";
import ClientPersonalInfoHandler from "../ClientPersonalInfo/ClientPersonalInfoHandler";
import DocumentCloudHandler from "../DocumentCloud/DocumentCloudHandler";
import {mapGetters} from "vuex";
import cloudsHelpers from "@/mixins/cloudsHelpers";
import ClientNoteHandler from "@/components/shared/PopupHandler/Popups/ClientNote/ClientNoteHandler.vue";
import AppIcon from "@/components/shared/AppIcon.vue";

export default {
  name: "UserManagerPopUp",
  components: {
    AppIcon,
    ClientNoteHandler,
    DocumentCloudHandler,
    ClientPersonalInfoHandler, ClientChatHandler, BrokerPickerHandler, MortgagePickerHandler
  },
  props: {
    payload: [Object, null],
    type: [Object],
  },
  computed: {
    ...mapGetters({
      refreshGetter: "popupManagerState/getUserManagerRefresh",
      popupSuccessResult: "popupManagerState/getPopupSuccessResult",

      getFormByType: "formStore/getFormByType",

      typeByClientFlow: "clientState/getTypeByClientFlow",
      typeByClientProfile: "clientState/getTypeByClientProfile",
    }),

    clientType1() {
      const clientFlow = this.clientData.client_profile.client_flow_status.flow.key;
      return this.typeByClientFlow(clientFlow);
    },
    currentFlowIndex() {
      if (!this.clientFlowData || !this.clientFlowChoices) return -1;
      return this.clientFlowChoices.findIndex((option) => option.value === this.clientFlowData.flow.key);
    },
    flowCompletedCount() {
      return this.currentFlowIndex < 0 ? 0 : this.currentFlowIndex + 1;
    },
    flowProgressWidth() {
      if (!this.clientFlowChoices || !this.clientFlowChoices.length) return "0%";
      return `${Math.round((this.flowCompletedCount / this.clientFlowChoices.length) * 100)}%`;
    },
    currentMortgageId() {
      const mortgageId = Number(this.$route.params.hypoteka);
      return Number.isInteger(mortgageId) ? mortgageId : null;
    },
  },
  mixins: [
    cloudsHelpers,
  ],
  data: () => ({
    cloudsLoaded: false,
    loading: false,
    loadError: '',
    form: null,
    role: null,
    clientData: null,
    brokerImage: null,
    open: false,
    clientType: null,
    clientLoaded: false,
    cloudsMeta: null,
    clientFlowData: null,
    clientFlowChoices: [],
  }),
  async created() {
    this.form = this.$store.getters["formStore/getFormByType"]("mortgageForm");
    this.role = this.$store.getters["userState/getRole"];
    await this.loadClient();
  },
  watch: {
    popupSuccessResult(event) {
      if (!event || typeof event !== "object") return;
      if (this.clientData?.id !== event.client || !Object.prototype.hasOwnProperty.call(event, "reason")) return;

      this.archiveClient(event.reason, false);
    },
    async refreshGetter(shouldRefresh) {
      if (!shouldRefresh) return;
      await this.loadClient();
      this.$store.commit("popupManagerState/setUserManagerRefresh", false);
    },
  },
  methods: {
    async loadClient() {
      if (this.loading) return;
      this.loading = true;
      this.loadError = '';
      this.clientLoaded = false;
      this.clientFlowData = null;
      try {
        // Calendar participants contain only basic user data. Fetch the profile
        // before rendering any field or deriving the client's workflow.
        const client = await getClientById(this.payload.id, "incomes.zamestnavatel,debts,client_profile,mortgages.coapplicant.incomes.zamestnavatel,mortgages.coapplicant.debts,mortgages.applications.bank");
        if (!client.client_profile || typeof client.client_profile !== 'object') throw new Error('Missing profile');
        this.clientData = {...client, email: client.email || '', mortgages: client.mortgages || []};
        const flow = client.client_profile.client_flow_status;
        if (flow?.flow?.key) {
          this.clientFlowData = JSON.parse(JSON.stringify(flow));
          this.clientFlowChoices = this.getFormByType("clientProfileForm")?.client_flow_status?.children?.flow?.children?.key?.choices || [];
        }
        const mortgageId = this.$store.getters["mortgageDetailState/getMortgage"]?.id;
        this.clientType = null;
        if (mortgageId) {
          const mortgage = this.clientData.mortgages.find(item => item.id === mortgageId);
          this.clientType = mortgage?.applicant === client.id ? "Žiadateľ" : "Spolužiadateľ";
        }
        this.clientLoaded = true;
      } catch (error) {
        this.loadError = [403, 404].includes(error.response?.status)
          ? 'Údaje klienta nie sú dostupné pre tento účet. Skontrolujte jeho pridelenie.'
          : 'Údaje klienta sa nepodarilo načítať. Skúste to znova.';
      } finally {
        this.loading = false;
      }
      if (this.clientLoaded) {
        try {
          this.cloudsMeta = await this.getCloudMeta();
          this.cloudsLoaded = true;
        } catch {
          this.cloudsLoaded = false;
        }
      }
    },
    openConsultation() {
      this.$store.commit("clientsEvents/setConsultationClient", this.clientData);
      this.$store.commit("popupManagerState/resetPopupOrder");
      this.$store.commit("appState/setCalendarVisible", true);
    },
    openQuickProcessedMortgage() {
      this.$store.commit("popupManagerState/pushToPopupOrder", {
        type: "full-width",
        payload: {
          id: this.clientData.id,
          first_name: this.clientData.first_name,
          last_name: this.clientData.last_name,
        },
        component: "QuickProcessedMortgagePopUp",
        rules: ["single"],
      });
    },
    flowTaskState(index) {
      if (index < this.currentFlowIndex) return "is-completed";
      if (index === this.currentFlowIndex) return "is-current";
      if (index === this.currentFlowIndex + 1) return "is-next";
      return "is-upcoming";
    },
    flowTaskHint(index) {
      if (index < this.currentFlowIndex) return "Dokončené";
      if (index === this.currentFlowIndex) return `Aktuálny krok · ${this.transformDate(this.clientFlowData.checked_at)}`;
      if (index === this.currentFlowIndex + 1) return "Nasledujúca úloha";
      return "Čaká na spracovanie";
    },
    async setClientObStatus(status) {
      const clientProfile = this.clientData.client_profile;
      if (clientProfile.ob_status === status)
        return;

      const updated = await this.$store.dispatch("clientState/patchClientObStatus", {
        id: clientProfile.id,
        status,
        type: this.typeByClientProfile(clientProfile),
        currentProfile: {
          user: clientProfile.user,
          client_flow_status: clientProfile.client_flow_status,
          ob_status: clientProfile.ob_status,
        },
      });

      if (updated) this.closePopup();
    },

    async openMortgage (id) {
      if (this.currentMortgageId === Number(id)) {
        this.$store.commit("popupManagerState/resetPopupOrder");
        return;
      }
      await this.$router.push({
        name: "KartaHypotekyDetail",
        params: {hypoteka: id},
      });
      this.$store.commit("popupManagerState/resetPopupOrder");
    },
    async createMortgage() {
      const role = this.$store.getters["userState/getRole"];
      let broker = null;
      if (role === "financnik") {
        broker = this.$store.getters["userState/getId"];
      } else if (role === "alex_admin") {
        broker = this.clientData.financnik;
      }
      const mortgageInfo = {
        applicant: this.payload.id,
        stage: "vyber_riesenia",
        financnik: broker,
      };
      await this.$store.dispatch("mortgagesState/postMortgage", mortgageInfo);
      const client = await getClientById(this.payload.id, "mortgages");
      this.clientData.mortgages = client.mortgages;
    },
    getDate(pDate) {
      const date = new Date(pDate);
      return `${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()}`;
    },
    async toggleClientFlowOption(option) {
      this.$store.commit("appState/setLoadingPage", true);
      try {
        const patchedProfile = await this.$store.dispatch("clientState/patchClientFlowState", {
          profile: this.clientData.client_profile,
          type: this.clientType1,
          flow: {
            key: option
          }
        });
        if (patchedProfile) {
          this.clientFlowData = patchedProfile.client_flow_status;
        }
      } finally {
        this.$store.commit("appState/setLoadingPage", false);
      }
    },
    transformDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString('sk-SK', {
        day: 'numeric', month: 'numeric', year: 'numeric', hour: "numeric", minute: "numeric"
      });
    },
    async getCloudMeta() {
      let cloudMeta = {};
      const currentComponent = this.$route.name;
      let mortgageId = null;
      if (currentComponent === "KartaHypotekyDetail") {
        const mortgage = this.$store.getters["mortgageDetailState/getMortgage"];
        mortgageId = mortgage.id;
        const currentMortgageCloud = this.$store.getters["mortgageDetailCloud/getFullClouds"];
        cloudMeta = {
          [mortgageId]: {
            clouds: currentMortgageCloud._.clouds,
            type_label: `Cloud hypotéky ${mortgage.id}, ${this.getMortgagePurpose(mortgage) ? this.getMortgagePurpose(mortgage) + "," : ""} ${this.getMortgageAmount(mortgage)}€`
          }
        };
        cloudMeta[mortgageId].clouds = this.filterInvisibleClouds(cloudMeta[mortgageId].clouds);
      }
      for (const mortgage of this.clientData.mortgages) {
        if (mortgageId === mortgage.id) continue;
        const clouds = await this.constructAllRelatedCloudsToMortgage(mortgage);
        cloudMeta = {
          ...cloudMeta,
          [mortgage.id]: {
            clouds,
            type_label: `Cloud hypotéky ${mortgage.id}, ${this.getMortgagePurpose(mortgage) ? this.getMortgagePurpose(mortgage) + "," : ""} ${this.getMortgageAmount(mortgage)}€`
          }
        };
      }
      return cloudMeta;
    },
    async constructAllRelatedCloudsToMortgage(mortgage) {
      let clouds = await cloudsHelpers.methods.constructAllRelatedCloudsToMortgage({
        ...mortgage,
        applicant: this.clientData
      }, mortgage.id);
      clouds = this.filterInvisibleClouds(clouds);
      return this.getCloudsObjectsFromCloud(clouds, mortgage.id);
    },
    async copyTextToClipboard() {
      await navigator.clipboard.writeText(this.value);
      this.success = true;
      setTimeout(() => {
        this.success = false;
      }, 1000);
    },
    getCloudsObjectsFromCloud(pClouds, mortgageId) {
      let clouds = [];
      for (const cloudFullObject of pClouds) {
        clouds = [...cloudFullObject.cloudMeta[mortgageId].clouds, ...clouds];
      }
      return clouds
    },
    getMortgagePurpose(mortgage) {
      let historyPurpose = this.maxKey(this.getMortgageAmountsFromHistory(mortgage.offers_filter_history));
      if (!historyPurpose) {
        historyPurpose = mortgage.hlavny_ucel;
      }
      if (!historyPurpose) {
        historyPurpose = "suma_nadobudnutie"
      }
      historyPurpose = historyPurpose.split("_")[1];
      return this.getChoicesFromFormByKey("hlavny_ucel", historyPurpose);
    },
    getChoicesFromFormByKey(key, value) {
      for (const choice of this.form[key].choices) {
        if (choice.value === value) {
          return choice.display_name;
        }
      }
    },
    getMortgageAmount(mortgage) {
      const historyAmount = this.sum(this.getMortgageAmountsFromHistory(mortgage.offers_filter_history));
      if (historyAmount !== 0) return historyAmount;
      const clientAmount = mortgage.suma_nadobudnutie + mortgage.suma_refinancovanie + mortgage.suma_bezucel
      return clientAmount ? clientAmount : 0;
    },
    getMortgageAmountsFromHistory(historyObject) {
      if (!historyObject || Array.isArray(historyObject.broker) || historyObject.broker.history.length === 0) return 0;
      const lastHistoryObject = historyObject.broker.history[0];
      return {
        suma_bezucel: lastHistoryObject.suma_bezucel,
        suma_nadobudnutie: lastHistoryObject.suma_nadobudnutie,
        suma_refinancovanie: lastHistoryObject.suma_refinancovanie
      };
    },
    maxKey(object) {
      let maxValue = 0;
      let maxKey = null;
      for (const [key, value] of Object.entries(object)) {
        if (value <= maxValue) continue;
        maxKey = key;
      }
      return maxKey;
    },
    sum(object) {
      let sum = 0;
      for (const objectElement of Object.values(object)) {
        sum += objectElement;
      }
      return sum;
    },
    constructClientLabel() {
      if (this.clientData.first_name === "") {
        return `ID ${this.clientData.id}`;
      } else if (this.clientData.first_name !== "") {
        return `${this.clientData.first_name} ${this.clientData.last_name}`;
      }
      return '';
    },
    getClientInfo() {
      return {
        type: this.clientType,
        id: this.clientData.id,
        email: this.clientData.email,
        firstName: this.clientData.first_name,
        lastName: this.clientData.last_name
      };
    },
    async inviteClient(id) {
      this.loading = true;
      try {
        await inviteClientById(id);
        this.$store.commit("appState/setSuccessMessage", {
          text: "Klient bol úspešne pozvaný do aplikácie",
          type: "success"
        });
      } catch (e) {
        const detail = e?.response?.data?.detail;
        if (typeof detail === 'string' && detail.includes("User has no email or email ends with @nomail.bankari.sk")) {
          this.$store.commit("appState/setSuccessMessage", {
            text: "Pridajte klientovi email",
            type: "error"
          });
        } else {
          // voliteľné: fallback hlásenie
          this.$store.commit("appState/setSuccessMessage", {
            text: "Nastala chyba pri pozývaní klienta",
            type: "error"
          });
          console.error(e); // pomoc pri debugovaní
        }
      }
      this.loading = false;
    },

    closePopup() {
      this.$store.commit("popupManagerState/popItemFromPopupOrder");
    },
    async archiveClient(reason, check = false) {
      if (check) {
        this.$store.commit("popupManagerState/pushToPopupOrder", {
          type: null,
          payload: {client: this.clientData.id},
          component: "ArchiveClientPopUp",
          rules: ['single'],
        });

        return;
      }

      const clientProfile = this.clientData.client_profile;
      const patchedProfile = await this.$store.dispatch("clientState/archiveClient", {
        type: this.typeByClientProfile(clientProfile),
        clientProfileId: clientProfile.id,
        reason
      });
      this.clientData.client_profile = patchedProfile;

      this.closePopup();
    },
  },
};
</script>

<style lang="scss" scoped>
.client-load-state {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  padding: 24px 0;
  color: var(--app-text);
}
.quick-processed-deal {
  display: grid;
  width: 100%;
  margin: 18px 0 4px;
  padding: 14px;
  grid-template-columns: 38px minmax(0, 1fr) 18px;
  gap: 11px;
  align-items: center;
  border: 1px solid rgba(42, 139, 242, .25);
  border-radius: 12px;
  background: rgba(42, 139, 242, .07);
  color: var(--app-text);
  text-align: left;
  cursor: pointer;
}

.client-mortgage {
  border: 1px solid transparent;
  transition: border-color .18s ease, background .18s ease;
}

.client-mortgage.is-current-mortgage {
  border-color: var(--app-primary);
  background: var(--app-primary-soft);
  box-shadow: inset 3px 0 0 var(--app-primary);
}

.client-mortgage__title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.client-mortgage__current {
  padding: 4px 7px;
  border-radius: 999px;
  background: var(--app-primary);
  color: #fff;
  font-size: 8px;
  font-weight: 800;
  letter-spacing: .03em;
  text-transform: uppercase;
}

.quick-processed-deal:hover {
  border-color: rgba(42, 139, 242, .48);
  background: rgba(42, 139, 242, .11);
}

.quick-processed-deal__icon {
  display: grid;
  width: 38px;
  height: 38px;
  place-items: center;
  border-radius: 11px;
  background: var(--app-primary);
  color: white;
  font-size: 17px;
  font-weight: 900;
}

.quick-processed-deal__copy {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 2px;
}

.quick-processed-deal__copy strong {
  color: var(--app-text);
  font-size: 12px;
}

.quick-processed-deal__copy small {
  color: var(--app-text-muted);
  font-size: 9px;
  line-height: 1.35;
}

.quick-processed-deal__arrow {
  color: var(--app-primary);
  font-size: 23px;
  line-height: 1;
}

.overflow-wrap-break {
  overflow-wrap: break-word;
}

.popup-manager {
  width: min(1180px, 78vw) !important;
  display: flex;
  flex-direction: row;
}

.taskList {
  padding: 24px;
}

.taskList.white {
  background-color: var(--app-surface);
  color: var(--app-text);
  height: 100%;
  overflow: scroll;
  scrollbar-width: none;
}

.client-flow-panel {
  flex: 0 0 46%;
  border-right: 1px solid var(--app-border);
  background: var(--app-bg) !important;
}

.content-form-popup.w-50 {
  width: 54% !important;
}

.client-flow-heading {
  display: flex;
  margin-bottom: 12px;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.client-flow-eyebrow {
  color: var(--app-primary);
  font-size: 10px;
  font-weight: 800;
  text-transform: uppercase;
}

.client-flow-title {
  margin-top: 3px;
  color: var(--app-text);
  font-size: 18px;
  font-weight: 800;
}

.client-flow-count {
  padding: 6px 9px;
  border: 1px solid var(--app-border);
  border-radius: 9px;
  background: var(--app-surface-muted);
  color: var(--app-text-muted);
  font-size: 10px;
  font-weight: 800;
}

.client-flow-progress {
  height: 6px;
  margin-bottom: 16px;
  overflow: hidden;
  border-radius: 999px;
  background: var(--app-surface-strong);
}

.client-flow-progress span {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: var(--app-primary);
  transition: width 0.25s ease;
}

.client-flow-list {
  display: flex;
  flex-direction: column;
  gap: 7px;
}

.client-flow-task {
  box-sizing: border-box;
  display: flex;
  width: 100%;
  min-height: 58px;
  padding: 10px 12px;
  align-items: center;
  gap: 11px;
  border: 1px solid var(--app-border);
  border-radius: 11px;
  background: var(--app-surface);
  color: var(--app-text);
  font-family: inherit;
  text-align: left;
  cursor: pointer;
  transition: border-color 0.18s ease, background 0.18s ease, transform 0.18s ease;
}

.client-flow-task:hover {
  border-color: var(--app-primary);
  transform: translateX(2px);
}

.client-flow-task.is-completed {
  background: var(--app-success-soft);
}

.client-flow-task.is-current {
  border-color: var(--app-primary);
  background: var(--app-primary-soft);
  box-shadow: 0 0 0 2px color-mix(in srgb, var(--app-primary) 12%, transparent);
}

.client-flow-task.is-next {
  border-style: dashed;
}

.client-flow-task.is-upcoming {
  opacity: 0.72;
}

.client-flow-marker {
  display: inline-flex;
  width: 28px;
  height: 28px;
  flex: 0 0 28px;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--app-border);
  border-radius: 50%;
  background: var(--app-surface-muted);
  color: var(--app-text-muted);
  font-size: 10px;
  font-weight: 800;
}

.client-flow-task.is-completed .client-flow-marker {
  border-color: var(--app-success);
  background: var(--app-success);
  color: #ffffff;
}

.client-flow-task.is-current .client-flow-marker {
  border-color: var(--app-primary);
  background: var(--app-primary);
  color: #ffffff;
}

.client-flow-copy {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 2px;
}

.client-flow-copy strong {
  color: var(--app-text);
  font-size: 11px;
  font-weight: 700;
  line-height: 1.35;
}

.client-flow-copy small {
  color: var(--app-text-muted);
  font-size: 9px;
  line-height: 1.3;
}

.popupSection {
  padding: 20px;
  margin-bottom: -10px;
}

.status-list {
  align-items: stretch !important;
  gap: 8px;
}

.status-option {
  width: 100%;
  padding: 9px 10px;
  align-items: center;
  gap: 10px;
  border: 1px solid transparent;
  border-radius: 10px;
  color: var(--app-text);
  transition: border-color 0.18s ease, background 0.18s ease;
}

.status-option:hover,
.status-option.is-selected {
  border-color: var(--app-border);
  background: var(--app-primary-soft);
}

.status-option .checkboxWrapper {
  width: 24px;
  height: 24px;
  padding: 6px;
  flex: 0 0 24px;
  border: 1px solid var(--app-border);
  background: var(--app-surface-muted);
  box-shadow: none;
}

.status-option .checkboxWrapper.is-selected {
  border-color: var(--app-primary);
  background: var(--app-primary-soft);
}

.back-button-wrapper,
.contact-icon {
  color: var(--app-primary);
}

.back-button-wrapper {
  display: inline-flex;
  width: 40px;
  height: 40px;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--app-border);
  border-radius: 12px;
  background: var(--app-surface-muted);
  transition: border-color 0.18s ease, background 0.18s ease;
}

.back-button-wrapper:hover {
  border-color: var(--app-primary);
  background: var(--app-primary-soft);
}

.email-cta {
  border: 1px solid var(--app-border);
  border-radius: 12px;
  background: var(--app-surface);
}

@media screen and (max-width: 992px) {
  .popup-manager {
    width: 90% !important;
  }
}

@media screen and (max-width: 767px) {
  .popup-manager {
    width: 90% !important;
    flex-direction: column-reverse;
    overflow: auto;
  }
  .taskList.white {
    height: auto;
    width: 100% !important;
    overflow: visible;
  }
  .taskList {
    height: auto;
  }
  .content-form-popup{
    height: 100%;
    width: 100% !important;
    overflow: visible;
  }
  .popup-form{
    height: 100%;
    overflow: scroll;
  }
}

.single-row {
  grid-template-rows: 1fr !important;
}

.invite-button {
  font-size: 13px;
}

.dark-blue-cta-text {
  padding: 0;
}

.div-block-28 {
  text-align: left;
  margin-left: 10px;
}

.client-name-block {
  justify-content: left;
}

.payload-name-block {
  position: relative;
}

.client-consultation-cta {
  display: grid;
  min-height: 88px;
  grid-template-columns: 50px minmax(0, 1fr) auto;
  width: 100%;
  align-items: center;
  gap: 14px;
  margin: 18px 0 12px;
  padding: 18px 20px;
  border: 1px solid var(--app-primary, #2f85d8);
  border-radius: 16px;
  background: var(--app-primary, #2f85d8);
  box-shadow: 0 12px 28px rgba(47, 133, 216, .22);
  color: #fff;
  text-align: left;
  cursor: pointer;
  transition: transform .18s ease, box-shadow .18s ease, filter .18s ease;
}

.client-consultation-cta:hover {
  transform: translateY(-2px);
  box-shadow: 0 16px 34px rgba(47, 133, 216, .3);
  filter: brightness(1.04);
}

.client-consultation-cta:focus-visible {
  outline: 3px solid rgba(89, 174, 255, .42);
  outline-offset: 3px;
}

.client-consultation-cta__icon {
  display: grid;
  width: 50px;
  height: 50px;
  place-items: center;
  border: 1px solid rgba(255, 255, 255, .28);
  border-radius: 14px;
  background: rgba(255, 255, 255, .14);
}

.client-consultation-cta span:nth-child(2) {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.client-consultation-cta strong {
  color: #fff;
  font-size: 14px;
  line-height: 1.3;
}

.client-consultation-cta small {
  color: rgba(255, 255, 255, .82);
  font-size: 10px;
  line-height: 1.4;
}

.client-consultation-cta span:last-child {
  color: #fff;
  font-size: 26px;
}


.broker-grid-buttons {
  grid-template-columns: repeat(3, minmax(50px, 1fr));
}

.div-block-85 {
  right: 0;
}

.popup-block {
  display: inline-block;
  align-items: center;
  justify-content: center;
  width: 100%;
  font-weight: 500;
}

.popupz {
  z-index: 5555;
}

.popup-block-chat {
  padding: 40px;
}

.popup {
  width: 34%;
  position: absolute !important;
  top: 0;
  overflow-y: auto;
  transition-duration: 0.5s;
}

.icon-btn {
  padding: 0;
  font-weight: 400 !important;

  img {
    margin-right: 4px;
  }
}
</style>
